
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2.821","y":"1.611","width":"12.358","height":"14.778","rx":".5","stroke":"#798f8f"}}),_c('mask',{staticClass:"i-path-2-inside-1_1434_46",attrs:{"fill":"#fff"}},[_c('rect',{attrs:{"x":"4.697","y":"6.464","width":"8.698","height":"8.039","rx":".5"}})]),_c('rect',{attrs:{"x":"4.697","y":"6.464","width":"8.698","height":"8.039","rx":".5","stroke":"#798f8f","stroke-width":"2","mask":"url(#path-2-inside-1_1434_46)"}})])
          )
        }
      }
    